



////////////////////////
///////////////////////
// Bundle Tabs
let currentBundleIndex = 0;
    const bundles = document.querySelectorAll('.bundle-content .image-container');
    const tabs = document.querySelectorAll('.tabs .tab');
    const items = document.querySelectorAll('.items');

    function showBundle(index) {
        bundles.forEach(bundle => bundle.classList.remove('active'));
        bundles[index].classList.add('active');

        tabs.forEach((tab, tabIndex) => {
            if (tabIndex === index) {
                tab.classList.add('active');
                tab.setAttribute('aria-label', 'active');
            } else {
                tab.classList.remove('active');
                tab.removeAttribute('aria-label');
            }
        });

        items.forEach(item => item.classList.remove('active'));
        items[index].classList.add('active');
    }

    function nextBundle() {
        currentBundleIndex = (currentBundleIndex + 1) % bundles.length;
        showBundle(currentBundleIndex);
    }

    function prevBundle() {
        currentBundleIndex = (currentBundleIndex - 1 + bundles.length) % bundles.length;
        showBundle(currentBundleIndex);
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            currentBundleIndex = index;
            showBundle(currentBundleIndex);
        });
    });